import React, {useContext, useEffect, useRef, useState} from 'react';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { classNames } from 'primereact/utils';
import {UserService} from "../services/UserService";
import {MainPageContext} from "./MainPage";

export default function Registration({onRegistration}) {
    const [showMessage, setShowMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [formData, setFormData] = useState({});
    const userservice = new UserService();

    const mp = useContext(MainPageContext);


    const formik = useFormik({
        initialValues: {
            username: '',
            email: '',
            password: '',
            passwordrep: '',
        },
        validate: (data) => {
            let errors = {};

            if (!data.username) {
                errors.username = 'Username is required.';
            } else if (data.username.length < 3) {
                errors.username = 'Username must be at least 3 characters long';
            } else if (!/^\S*$/.test(data.username)) {
                errors.username = 'Whitespace characters are not allowed';
            }

            if (!data.email) {
                errors.email = 'Email is required.';
            }
            else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(data.email)) {
                errors.email = 'Invalid email address.';
            }

            if (!data.password) {
                errors.password = 'Password is required.';
            }
            else if (data.password.length < 8) {
                errors.password = 'Password must be at least 8 characters long';
            }

            if (data.passwordrep !== data.password) {
                errors.passwordrep = 'Passwords are not identical';
            }

            return errors;
        },
        onSubmit: (data) => {
            setFormData(data);

            //delete data.passwordrep;
            data.active = true;
            userservice.createUser(data).then((res) => {
                if(res.status === 200) {
                    res.json().then(data => {
                        onRegistration(data);
                        mp.mainToast.current.show({
                            severity: 'success',
                            summary: 'Registration successful.',
                            life: 6000
                        });
                        formik.resetForm();
                    })
                }
                else
                {
                    res.json().then(error => {
                        mp.mainToast.current.show({severity: 'error', summary: 'Could not register user.', detail: error?.detail, sticky: true});
                    })
                }
            })

        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const dialogFooter = <div className="flex justify-content-center"><Button label="OK" className="p-button-text" autoFocus onClick={() => setShowMessage(false)} /></div>;
    const passwordHeader = <h6>Pick a password</h6>;
    const passwordFooter = (
        <React.Fragment>
            <Divider />
            <p className="mt-2">Requirements</p>
            <ul className="pl-2 ml-2 mt-0" style={{ lineHeight: '1.5' }}>
                <li>Minimum 8 characters</li>
            </ul>
        </React.Fragment>
    );

    return (
        <div>
            <Dialog visible={showMessage} onHide={() => setShowMessage(false)}
                    position="top"  showHeader={false} breakpoints={{ '960px': '80vw' }} style={{ width: '30vw' }} closable={true}  closeOnEscape={true}>
                <div className="flex align-items-center flex-column pt-6 px-3">
                    <h5>Registration Successful!</h5>
                    <p style={{ lineHeight: 1.5, textIndent: '1rem' }}>
                        Dear <b>{formData.username}</b>  make sure your email address (<b>{formData.email}</b>) is correct/up to date to be able to reset the password (to be implemented :) ).
                    </p>
                </div>
            </Dialog>

            <div className="flex justify-content-center">
                <div className="card">
                    <form onSubmit={formik.handleSubmit} className="p-fluid">
                        <div className="field">
                            <span className="p-float-label">
                                <InputText id="username" name="username" value={formik.values.username} onChange={formik.handleChange} autoFocus className={classNames({ 'p-invalid': isFormFieldValid('username') })} />
                                <label htmlFor="username" className={classNames({ 'p-error': isFormFieldValid('username') })}>Username</label>
                            </span>
                            {getFormErrorMessage('username')}
                        </div>
                        <div className="field">
                            <span className="p-float-label p-input-icon-right">
                                <InputText id="email" name="email" value={formik.values.email} onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('email') })} />
                                <label htmlFor="email" className={classNames({ 'p-error': isFormFieldValid('email') })}>Email</label>
                            </span>
                            {getFormErrorMessage('email')}
                        </div>
                        <div className="field">
                            <span className="p-float-label">
                                <Password id="password" name="password" value={formik.values.password} onChange={formik.handleChange} toggleMask
                                          className={classNames({ 'p-invalid': isFormFieldValid('password') })} header={passwordHeader} footer={passwordFooter} />
                                <label htmlFor="password" className={classNames({ 'p-error': isFormFieldValid('password') })}>Password</label>
                            </span>
                            {getFormErrorMessage('password')}
                        </div>
                        <div className="field">
                            <span className="p-float-label">
                                <Password id="passwordrep" name="passwordrep" value={formik.values.passwordrep} onChange={formik.handleChange} toggleMask feedback={false}
                                          className={classNames({ 'p-invalid': isFormFieldValid('passwordrep') })}/>
                                <label htmlFor="passwordrep">Password (repeat)</label>
                            </span>
                            {getFormErrorMessage('passwordrep')}
                        </div>

                        <Button type="submit" label="Register" className="mt-2"/>
                    </form>
                </div>
            </div>
        </div>
    );
}